const reportingClinicianTypes = {
  FETCH_ALL_REPORTING_CLINICIANS: 'FETCH_ALL_REPORTING_CLINICIANS',
  UPDATE_REPORTING_CLINICIAN_STATUS: 'UPDATE_REPORTING_CLINICIAN_STATUS',
  SINGLE_REPORTING_CLINICIAN: 'SINGLE_REPORTING_CLINICIAN',
  EDIT_REPORTING_CLINICIAN: 'EDIT_REPORTING_CLINICIAN',
  FETCH_PATIENT_REPORT_ASSIGNED: 'FETCH_PATIENT_REPORT_ASSIGNED'
};

export default reportingClinicianTypes;
